/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
export class ConditionRowLanguageSource {
  get groupWithNextRowLabel() {
    return AbReactResources.abBooleanLogicTree_menu_groupWithNextCondition();
  }
  get deleteRowLabel() {
    return AbReactResources.abBooleanLogicTree_menu_deleteCondition();
  }
  get addRowLabel() {
    return AbReactResources.abBooleanLogicTree_addCondition();
  }
}
//# sourceMappingURL=ConditonRowLanguageSource.js.map
